<template>
  <div data-app>
    <div class="uk-section_">
      <preloader :is-visible="isLoading"></preloader>
      <div v-if="!isLoading && local_page_keys !== null" class="uk-card uk-card-default">
        <!--шапка-->
        <div class="uk-card-header">
          <div class="uk-grid uk-flex-middle" data-uk-grid>
            <div class="uk-width-expand">
              <h3 class="uk-card-title uk-margin-remove-top">
                {{ local_page_keys.title_elements_page }}
              </h3>
            </div>
            <div class="uk-width-auto">
              <div class="uk-grid uk-grid-small" data-uk-grid>
                <!--add btn-->
                <!--                <div>-->
                <!--                  <button class="uk-button tm-button-success" type="button" @click="showedCategoryModal = true">-->
                <!--                    Добавить тип функции-->
                <!--                  </button>-->
                <!--                </div>-->
                <div>
                  <button class="uk-button tm-button-success" type="button" @click="showedIntensityModal = true">
                    Добавить усилитель функции
                  </button>
                </div>
                <div>
                  <button class="uk-button tm-button-success" type="button" @click="openCreate">
                    Добавить фукнцию
                  </button>
                </div>
                <!--search-->
                <div>
                  <div class="uk-search uk-search-default" style="width: 300px;" v-if="listType === 'functions'">
                    <span data-uk-search-icon class="uk-icon uk-search-icon"></span>
                    <input class="uk-search-input" v-model="searchString" type="search" placeholder="Поиск">
                  </div>
                </div>

                <div>
                  <select class="uk-select" v-model="listType">
                    <option value="functions">Функции</option>
                    <option value="categories">Типы функции</option>
                    <option value="intensities">Усилитель функции</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--список функций-->
        <FunctionTable
            v-if="listType === 'functions'"
            :functions="functions"
            :searchString="searchString"
            :local_page_keys="local_page_keys"
            @openEdit="openEdit"/>

        <template v-if="listType === 'categories'">

          <!--список типов-->
          <!--шапка-->
          <div class="uk-text-bold" style="background-color: #4caf50; color: #fff;">
            <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid" data-uk-grid>
              <div class="uk-width-auto">
                <div style="width: 60px;" class="uk-padding-small">
                  id
                </div>
              </div>
              <div class="uk-width-expand">
                <div class="uk-padding-small">
                  Название типа функции
                  <a href="#" class="uk-display-inline-block uk-link-reset"
                     data-uk-tooltip="title: Сортировка по названию">
                  <span class="uk-icon" @click="typeSorting('asc')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line>
                    </svg>
                  </span>
                    <span class="uk-icon uk-link-reset" style="margin-left: -6px;"
                          @click="typeSorting('desc')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line>
                    </svg>
                  </span>
                  </a>
                </div>
              </div>
              <div class="uk-width-auto">
                <div style="width: 60px;" class="uk-padding-small"></div>
              </div>
            </div>
          </div>
          <!--список-->
          <template v-for="(type, type_key) in types">
            <div class="uk-grid-collapse uk-text-center uk-flex-middle tm-grid-bg-hover uk-grid" data-uk-grid
                 :key="type_key">
              <!--Иконка функции-->
              <div class="uk-width-auto">
                <div style="width: 60px;" class="uk-padding-small">
                  {{ type_key + 1 }}
                </div>
              </div>
              <!--Название типа функции-->
              <div class="uk-width-expand uk-text-left">
                <div class="uk-padding-small">
                  {{ type }}
                </div>
              </div>
              <div class="uk-width-auto">
              </div>
            </div>
            <hr class="uk-margin-remove" :key="'hr_'+type_key">
          </template>

        </template>

        <template v-if="listType === 'intensities'">
          <!--список усилителей-->
          <!--шапка-->
          <div class="uk-text-bold" style="background-color: #4caf50; color: #fff;">
            <div class="uk-grid-collapse uk-text-center uk-flex-middle uk-grid" data-uk-grid>
              <div class="uk-width-auto">
                <div style="width: 60px;" class="uk-padding-small">
                  id
                </div>
              </div>
              <div class="uk-width-expand">
                <div class="uk-padding-small">
                  Название усилителя функции
                  <a href="#" class="uk-display-inline-block uk-link-reset"
                     data-uk-tooltip="title: Сортировка по названию">
                  <span class="uk-icon" @click="capacitiesSorting('name','asc')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line>
                    </svg>
                  </span>
                    <span class="uk-icon uk-link-reset" style="margin-left: -6px;"
                          @click="capacitiesSorting('name','desc')">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon>
                      <line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line>
                    </svg>
                  </span>
                  </a>
                </div>
              </div>
              <div class="uk-width-medium">Категория</div>
              <div class="uk-width-auto">
                <div style="width: 60px;" class="uk-padding-small"></div>
              </div>
            </div>
          </div>
          <!--список-->
          <template v-for="capacity in capacities">
            <div class="uk-grid-collapse uk-text-center uk-flex-middle tm-grid-bg-hover uk-grid" data-uk-grid
                 :key="capacity.id">
              <!--Иконка функции-->
              <div class="uk-width-auto">
                <div style="width: 60px;" class="uk-padding-small">
                  {{ capacity.id }}
                </div>
              </div>
              <!--Название типа функции-->
              <div class="uk-width-expand uk-text-left">
                <div class="uk-padding-small">
                  {{ capacity.name }}
                </div>
              </div>
              <div class="uk-width-medium">Capacity</div>
              <div class="uk-width-auto">
                <div class="uk-padding-small uk-flex uk-text-center uk-flex-center" style="min-width: 50px;">
                  <button type="button"
                          @click="showedIntensityModal = true; selectedCapacity = capacity"
                          data-uk-icon="file-edit"
                          style="padding: 0 5px;"
                          class="uk-icon uk-link-text">
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                         data-svg="file-edit">
                      <path fill="none" stroke="#000"
                            d="M18.65,1.68 C18.41,1.45 18.109,1.33 17.81,1.33 C17.499,1.33 17.209,1.45 16.98,1.68 L8.92,9.76 L8,12.33 L10.55,11.41 L18.651,3.34 C19.12,2.87 19.12,2.15 18.65,1.68 L18.65,1.68 L18.65,1.68 Z"></path>
                      <polyline fill="none" stroke="#000"
                                points="16.5 8.482 16.5 18.5 3.5 18.5 3.5 1.5 14.211 1.5"></polyline>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <hr class="uk-margin-remove" :key="'key_'+capacity.id">
          </template>
        </template>
        <!--modal new func-->
        <ModalFunctionDialog
            :editedFunction="editedFunction"
            @close="closeModal"
            @reloadLocalize="getLocalized"
            @created="setEditedFunctionId"
            :capacities="capacities"
            :types="types"
            :local_page_keys="local_page_keys"
            v-if="showedEditModal"/>
        <!--modal новый тип-->
        <ModalFunctionCategoryDialog
            v-if="showedCategoryModal"
            @close="showedCategoryModal = false"/>
        <!--modal новый усилитель-->
        <ModalFunctionIntensityDialog
            v-if="showedIntensityModal"
            :languages-list="languages"
            :capacity="selectedCapacity"
            @reload="getTypeData"
            @close="showedIntensityModal = false; selectedCapacity = null"/>
      </div>
    </div>
  </div>
</template>

<script>
import validateImgExp from '../../../filters/validateImgExp'
import ModalFunctionDialog from "../Components/Dialogs/ModalFunctionDialog";
import ModalFunctionCategoryDialog from "../Components/Dialogs/ModalFunctionCategoryDialog";
import ModalFunctionIntensityDialog from "../Components/Dialogs/ModalFunctionIntensityDialog.vue";
import FunctionTable from "../Tables/FunctionTable";
import Preloader from "../Components/Preloader";
import axios from "axios";

export default {
  name: "FunctionsElements",
  components: {
    ModalFunctionDialog,
    FunctionTable,
    Preloader,
    ModalFunctionCategoryDialog,
    ModalFunctionIntensityDialog
  },
  data: () => ({
    tab: null,
    local_page_keys: null,
    element_name: null,
    element_url: null,
    elementsList: [],
    headers: [
      {
        text: 'Element name',
        value: 'name',
      },
      {
        text: 'Element url',
        value: 'image_path',
      },
    ],
    filters: [validateImgExp],
    selectedFile: null,
    validInputName: true,
    validInputUrl: true,
    isLoading: true,
    functionsList: [],
    searchString: '',
    editedFunctionId: null,
    showedEditModal: false,
    showedCreateModal: false,
    capacities: [],
    types: [],
    showedCategoryModal: false,
    showedIntensityModal: false,
    listType: 'functions',
    languages: [],
    selectedCapacity: null,
  }),

  computed: {
    functions() {
      let functions = this.$store.getters['functionsEdit/functionsList'];
      return functions.filter(func => func.id !== 250 && func.id !== 253).map(func => {
        func.functionTypes = func.types ? func.types.map(type => type.name) : [];
        let typeCapacity = func.types ? func.types.filter(type => type.name == 'capacity') : [];
        if (typeCapacity && typeCapacity[0] && typeCapacity[0].additional) {
          func.capacities = JSON.parse(typeCapacity[0].additional);
        }
        if (func.elements) {
          func.elements = func.elements.map(function (element) {
            element.number = parseInt(element.name.replace(/\D/g, ""));
            return element;
          }).sort((a, b) => (a['number'] > b['number']) ? 1 : ((b['number'] > a['number']) ? -1 : 0));
        }
        return func;
      });
    },
    editedFunction() {
      let filtered = this.functions.filter((item) => {
        return item.id == this.editedFunctionId
      });
      return filtered[0] ?? null;
    }
  },
  methods: {
    async getFunctionElementList() {
      await this.$store.dispatch('functionsEdit/functionsList');
      // let data = this.$store.getters['functionsEdit/functionsList'];
      // this.functions = data.list ? data.list : [];

      await this.$store.dispatch('funcElements/funcElementList');
      this.elementsList = this.$store.getters['funcElements/funcElementList'];
      this.isLoading = false;
    },
    openEdit(editedFunctionId) {
      this.editedFunctionId = editedFunctionId;
      this.showedEditModal = true;

      const url = window.location.href.split('#')[0] + '#' + this.editedFunction.name;
      window.history.pushState(null, null, url);
    },
    closeModal() {
      this.editedFunctionId = null;
      this.showedEditModal = false;
      let url = window.location.href;
      if(url.indexOf('#') > -1) url = url.split('#')[0];
      window.history.pushState(null, null, url);
      this.getLocalized();
    },
    openCreate() {
      this.editedFunctionId = null;
      this.showedEditModal = true;
    },
    setEditedFunctionId(id) {
      this.editedFunctionId = id;
    },
    async getTypeData() {
      await axios.get(`${process.env.VUE_APP_API_BASE_URL}/func/type-data`)
          .then(response => {
            if (response.data) {
              this.capacities = response.data.capacities ? response.data.capacities : [];
              this.types = response.data.types ? response.data.types : [];
              this.languages = response.data.languages ? response.data.languages : [];
            }
          });
    },
    async getLocalized() {
      this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('functions_elements'), await this.$filtergetLocalisationPage('ru_retoucher_translations'), await this.$filtergetLocalisationPage('services_lists_instructions'));
    },
    capacitiesSorting(field, type) {
      if (type === 'asc') {
        this.capacities = this.capacities.sort((a, b) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0));
      } else {
        this.capacities = this.capacities.sort((a, b) => (b[field] > a[field]) ? 1 : ((a[field] > b[field]) ? -1 : 0));
      }
    },
    typeSorting(type) {
      if (type === 'asc') {
        this.types = this.types.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
      } else {
        this.types = this.types.sort((a, b) => (b > a) ? 1 : ((a > b) ? -1 : 0));
      }
    },

  },
  async mounted() {
    await this.getLocalized();
    await this.getFunctionElementList();
    await this.getTypeData();

  }
}
</script>

<style>
/*Layout*/

@import '../../../assets/css/uikit/tab.css';
@import '../../../assets/css/uikit/iconnav.css';
@import '../../../assets/css/uikit/switcher.css';
@import '../../../assets/css/uikit/pagination.css';
@import '../../../assets/css/uikit/search.css';

.tm-val-error {
  border: 2px solid red;
  padding-bottom: 0;
}

.tm-grid-bg-hover:hover {
  transition: .3s ease-out;
  background-color: #eaeaea;
}

.uk-link-text a, a.uk-link-text {
  color: inherit !important;
}

.uk-hr, hr {
  overflow: visible;
  text-align: inherit;
  margin: 0 0 20px 0;
  border: 0;
  border-top: 1px solid #e5e5e5;
}

.tm-func-modal {
  width: 1000px;
}

.uk-button:not(:disabled) {
  cursor: pointer;
}

.uk-button.tm-button-success {
  background-color: #4caf50;
  color: #fff !important;
}

.uk-grid > * > :last-child {
  margin-bottom: 0;
}

[type=reset], [type=submit], button, html [type=button] {
  -webkit-appearance: button;
}

/*.uk-button {
  border-radius: 0;
}*/

.uk-button-default:focus, .uk-button-default:hover {
  color: #fff;
}

.uk-grid-divider.uk-grid-stack > .uk-grid-margin {
  margin-top: 0;
}

.uk-grid-divider.uk-grid-stack > .uk-grid-margin:before {
  top: 0;
  left: 0;
}

.tm-modal-func-icon img {
  width: 30px;
}

.tm-modal-func-icon {
  width: 40px;
  height: 40px;
}

.dropzone {
  position: relative;
  border: 1px dashed #ccc;
  color: #000;
  font: bold 16px/100px arial;
  height: 100%;
  text-align: center;
  width: 100%;
}

.dropzone img {
  vertical-align: middle;
  max-width: 95%;
  max-height: 95%;
}

.dropzone svg {
  vertical-align: middle;
  max-width: 95%;
  max-height: 95%;
}

.dropzone [type="file"] {
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: absolute;
  opacity: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.tm-left-slides-list .uk-tab > * > a {
  padding: 10px 10px 10px 10px;
}

.tm-left-slides-list .uk-tab > * > a,
.tm-left-slides-list .uk-tab > * {
  transition-property: color, background-color;
  cursor: pointer;
}

.tm-left-slides-list .uk-tab > *.uk-active,
.tm-left-slides-list .uk-tab > *:hover {
  background-color: #e8e8e8;
  transition: .2s ease-out;
}

.tm-left-slides-list .uk-tab > *:hover > a,
.tm-left-slides-list .uk-tab > * > a:hover {
  color: #333;
}

.tm-slider-add-bittons .uk-button {
  padding: 0 0px;
}

.tm-left-slides-list .uk-tab-left::before {
  display: none;
}

.uk-tab > .tm-block-item > a,
.uk-tab > .tm-slide-item > a {
  font-size: 12px;
}

.tm-file-rez {
  color: #fff;
  font-size: 12px;
  padding: 5px;
  background-color: #4caf50;
}

.tm-light,
.tm-light .md-icon,
.tm-light-hover:hover,
.tm-light-hover:focus {
  color: #fff !important;
}

.tm-example-img {
  position: relative;
  border: 1px dashed #ccc;
  background-color: #fff;
}

.tm-example-img img {
  max-height: 100%;
}

.uk-form-danger, .uk-form-danger:focus {
  color: #f00000 !important;
  border-color: #f00000 !important;
}
</style>